<template>
    <div class="label-header-container">
        <p class="icon"></p>
        <span>{{msg}}</span>
    </div>
</template>

<script>
    export default {
        name: "LabelHeader",
        props:['msg'],
        data() {
            return {

            };
        },
    }
</script>

<style scoped lang="css">
.label-header-container{
    border-bottom: 1px solid #eeeeee;
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    background-color: #F0F0F0;
    display: flex;
    align-items: center;
}
.label-header-container .icon {
    display: inline-block;
    margin:  5px;
    padding: 0;
    height: 18px;
    width: 4px;
    background-color: #409eff;
}
</style>